import React, { useEffect, useRef } from "react";

const OutSideClose = ({ onClickOutside, children }) => {
  const ref = useRef(null);

  const handleClickOutside = (event) => {
    if (ref.current && !ref.current.contains(event.target)) {
      onClickOutside(); // Trigger the callback when clicked outside
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [handleClickOutside]);

  return <div ref={ref}>{children}</div>;
};

export default OutSideClose;